import { storyblokEditable } from "@storyblok/react";
import React from "react";

const ServiceMysterycheck = ({ blok }) => (
  <div className="wrap" {...storyblokEditable(blok)}>
    <div className="mysterycheck-wrap">
      <h2 className="text-2xl merryweather">{blok.subheadline}</h2>
      <span>{blok.infotext_bold}</span>
      <p>{blok.infotext}</p>
      <div className="contact-partner flex flex-col">
        <span>Ihr Ansprechpartner:</span>
        <span>{blok.name}</span>
        <span>Telefon: {blok.phone}</span>
        <span>E-mail: {blok.email}</span>
      </div>

      <div className="scrollbox">
        <img className="mysterycheck-image"
          src="/src/hpew_mystery_check_20190404_890_075compression.gif"
        />
      </div>


      {/* Alternative for GIF   */}
      {/*  <div className="scrollbox">
        <div className="box">
          <ul>
            <li className="item-1">Wie sehr fühlen Sie sich willkommen/erwünscht</li>
            <li className="item-2">Wie angehnem empfanden Sie Ihren Besuch ingesamt?</li>
            <li className="item-3">Wurde die Beschwerde in Ihrem Sinne bearbeitet? </li>
            <li className="item-4">Wie diskret wurde Ihre Beschwerde behandelt? </li>
            <li className="item-5">Ist die Schaumhöhe des Bieres einwandfrei? </li>
            <li className="item-5">Wie gut schneckt Ihnen das Gericht? </li>
            <li className="item-5">Wie freundlich/Herzlich ist der Mitarbeiter? </li>
            <li className="item-5">Wie angemessen fanden Sie Ihren Besuch insgesamt? </li>
            <li className="item-5">Sauberkeit und Zustand der Sanitären Einrichtungen</li>
          </ul>
        </div>
      </div> */}
    </div>
  </div>
);

export default ServiceMysterycheck;
